<template>
  <field :label="$t(label)" :required="required" :classes="classes" v-model="newValue" :collection="statuses" :name="name" :value="value" :placeholder="placeholder" type="radio"></field>
</template>
<script>
import Field from '@/components/helpers/DataInput/FormField'
import Statuses from '@/config/data/user_statuses.js'

export default {
  name: 'user-status-select',
  components: { Field },
  props: {
    label: String,
    classes: Array,
    name: String,
    value: [String, Boolean],
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      statuses: Statuses,
      newValue: ''
    }
  },
  created () {
    this.newValue = this.value
  },
  watch: {
    value() {
      this.newValue = this.value
    },
    newValue () {
      this.$emit('input', this.newValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserStatusSelect.vue?cb969b48